// services/SupportService.js
import axios from "axios";
import { getConfig } from "../configService";

export class SupportService {
    static getBaseUrl() {
        if (
            window.location.hostname === "localhost" ||
            window.location.hostname === "127.0.0.1"
        ) {
            return "http://localhost:5052/v1"; // local support API base
        }
        return getConfig().apiBaseUrl + "/support-service/v1"; // adjust if behind a gateway
    }

    /**
     * Submits a support request to the support service
     * @param {Object} request - The support ticket payload
     * @param {string} request.role - "Providers" or "Clients"
     * @param {string} request.issue - Issue category (e.g., "Technical", "Payment")
     * @param {string} request.email - User's email address
     * @param {string} request.title - Short summary of the issue
     * @param {string} request.additionalInfo - Long-form message (optional)
     * @param {string} request.priority - "Critical", "High", "Normal", or "Low"
     * @returns {Promise} Axios response
     */
    static async submitSupportTicket(request) {
        try {
            const baseUrl = SupportService.getBaseUrl();
            const url = `${baseUrl}/Support`;

            return await axios.post(url, request, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
        } catch (error) {
            console.error("Support ticket submission failed:", error);
            return error.response;
        }
    }
}
